    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="id">
            <mat-header-cell [crud-column-header]="columns.column('id')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.id">
                Id
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.id | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expirationDate">
            <mat-header-cell [crud-column-header]="columns.column('expirationDate')" *matHeaderCellDef
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.expirationDate">
                Expiration Date
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.expirationDate | uimDateFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expiryDate">
            <mat-header-cell [crud-column-header]="columns.column('expiryDate')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.expiryDate">
                Expiry Date
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.expiryDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="linkData">
            <mat-header-cell [crud-column-header]="columns.column('linkData')" *matHeaderCellDef
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.linkData">
                Link Data
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.linkData}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.businessUnit">
                Business Unit
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.businessUnit == null ? "All BusinessUnits" : element.businessUnit?.buId + " - " + element.businessUnit?.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="businessUnitId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnitId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.businessUnitId">
                Business Unit ID
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.businessUnitId}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="message">
            <mat-header-cell [crud-column-header]="columns.column('message')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-large" i18n="@@type.SystemMessage.message">
                Message
              </mat-header-cell>
            <mat-cell class="search-column-large" *matCellDef="let element">
              {{element.message}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="uniqueId">
            <mat-header-cell [crud-column-header]="columns.column('uniqueId')" *matHeaderCellDef
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.uniqueId">
                Unique Id
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.uniqueId}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="userMessageType">
            <mat-header-cell [crud-column-header]="columns.column('userMessageType')" *matHeaderCellDef
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.SystemMessage.userMessageType">
                User Message Type
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.userMessageType}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>
    </div>
